import React, {useContext, useState, useEffect} from 'react';
import Marquee from "react-fast-marquee";
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {getApiBoardList} from 'api/data/cms';
import Themes from 'themes';
import './index.css';


const ThemeContext = React.createContext(Themes.themes1);


function MarqueeDefault () {
  const { t } = useTranslation();
  const Themes = useContext(ThemeContext);
  const [marquee, setMarquee] = useState({result:[]})
  useEffect(async() => {
      const res = await getApiBoardList();
      setMarquee(res);
      console.log('get Marquee:', res)
  },[])

  return(
    <div className="margueeBox" style={{ background: Themes.marqueebg, color: Themes.color}}>
    <Container>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} >
             <div className="margueeInBox">
               <span>{t('marquee.marqueeTitle')}</span>
               <Marquee speed={50}>
                 {marquee.result.map(item => <p key={item}>{item.title}{item.content}</p>)}
               </Marquee>
             </div>
        </Col>
      </Row>
    </Container>
    </div>
  )
}

export default MarqueeDefault
